<template>
  <div>
    <el-select
      ref="branch"
      v-model="selected"
      filterable
      v-loading="loading"
      :multiple="false"
      clearable
      :size="size"
      placeholder="Selecione uma filial..."
      @change="update()"
      remote
      collapse-tags
    >
      <el-option
        v-for="row of branchs"
        :key="row.id"
        :label="row.name"
        :value="row.id"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "BrachsList",
  data: function () {
    return {
      selected: "",
      loading: false,
    };
  },
  props: {
    current: String,
    size: "",
    branchs: Array,
  },
  watch: {
    current() {
      const vm = this;
      if (vm.$props.current) {
        vm.selected = vm.$props.current;
      }
    },
  },
  methods: {
    focus() {
      this.$refs.branch.$el.getElementsByTagName("input")[0].focus();
    },

    clear() {
      this.selected = "";
    },

    update() {
      this.$emit("selected", this.selected);
    },
  },
  mounted() {
    const vm = this;
  },
};
</script>
